module.exports = __webpack_public_path__ + "img/independent001.ed2fece0.jpg";